import { routeNames } from '@/router';
import { TripPatternDto } from '@/types/webapi';
import { useRouter } from 'vue-router';
import { useTripSearchStore } from '../../stores';
import { isError } from 'lodash-es';
import { addDays, isBefore } from 'date-fns';
import { storeToRefs } from 'pinia';
import { useMainStore } from '@/features/common/stores';
import { computed, ref } from 'vue';

export function useTripSharing(props: { tripPattern: TripPatternDto }) {
    const router = useRouter();
    const tripSearchStore = useTripSearchStore();
    const { currentTime, config } = storeToRefs(useMainStore());

    const isLoading = ref(false);
    const shareLink = ref<string | undefined>(undefined);

    async function saveTripPattern() {
        try {
            // if we have already saved the trip pattern, don't save it again
            if (shareLink.value) return;

            isLoading.value = true;

            const saved = await tripSearchStore.saveTripPatternById(props.tripPattern.id);

            isLoading.value = false;

            if (!saved) return;

            const route = router.resolve({ name: routeNames.tripSearch, params: { id: props.tripPattern.id } });
            shareLink.value = new URL(route.href, window.location.origin + window.location.pathname).href;
        } catch (e) {
            isLoading.value = false;

            // ignore abort share error
            if (!isError(e) || e.name !== 'AbortError') {
                throw e;
            }
        }
    }

    const canShare = computed(() => {
        if (!config.value.searchConfig?.sharing?.enabled) {
            return false;
        }

        // check if trip pattern starts within max days ahead
        return isBefore(props.tripPattern.aimedStartTime, addDays(currentTime.value, config.value.searchConfig.sharing.maxDaysAhead));
    });

    return {
        saveTripPattern,
        canShare,
        shareLink,
        isLoading
    };
}
